import clsx from "clsx";
import NetworkImage from "./NetworkImage";

export default function NetworkImageWithLink(m: {
  image: string;
  link?: string;
  className?: string;
}) {
  return m.link ? (
    <a href={m.link} target="_blank" rel="noreferrer">
      <NetworkImage
        src={m.image}
        className={clsx(
          "h-[8.75rem] w-full rounded-[0.75rem] sm:h-[22.5rem] sm:rounded-[1.25rem]",
          m.className,
        )}
      />
    </a>
  ) : (
    <NetworkImage
      src={m.image}
      className={clsx(
        "h-[8.75rem] w-full rounded-[0.75rem] sm:h-[22.5rem] sm:rounded-[1.25rem]",
        m.className,
      )}
    />
  );
}
